import { render, staticRenderFns } from "./AppVersionsOnTest.vue?vue&type=template&id=74ba8727&scoped=true&"
import script from "./AppVersionsOnTest.vue?vue&type=script&lang=js&"
export * from "./AppVersionsOnTest.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionsOnTest.vue?vue&type=style&index=0&id=74ba8727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba8727",
  null
  
)

export default component.exports